// supervisor-run-header-progress-line.ts
//
// Req 1 (B16): the FIRST progress line of a `run`, before any ▶ — only pays
// for the extra ticket read when a caller actually wants progress (unit tests
// without `progress` never touch the filesystem for this). Split out of
// supervisor-run-until-idle.ts (review 06g M1, line budget), moved verbatim.
import { formatRunHeaderLine } from "./run-progress-lines.js";
import type { RunUntilIdleInput } from "./supervisor-run-until-idle-types.js";
import { buildSchedulerProjection, loadTicketsFromRepo } from "./supervisor-ticket-projection.js";

export async function emitRunHeaderProgressLine(
  input: Pick<RunUntilIdleInput, "progress" | "repoDir" | "store" | "missionId">,
): Promise<void> {
  if (!input.progress) return;
  const headerTickets = await loadTicketsFromRepo(input.repoDir);
  const headerProjection = buildSchedulerProjection(headerTickets, input.store.state.tickets);
  const doneCount = headerTickets.filter(
    (t) => headerProjection.ticketStatus[t.id] === "done",
  ).length;
  input.progress(
    formatRunHeaderLine(
      input.missionId,
      headerTickets.length,
      doneCount,
      headerTickets.length - doneCount,
    ),
  );
}
